import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

let ScrollTriggerInit = gsap.registerPlugin( ScrollTrigger );
let ScrollToInit = gsap.registerPlugin( ScrollToPlugin );
let mm = gsap.matchMedia();

$( window ).on( 'load', () => {

  $('.text, p, h2, h3, h4, h5, h6 ').each( function(){
    
    let p = this.innerHTML.split(" ");

    if ( p.length > 1 ) {
      p[ p.length - 2 ] += "&nbsp;" + p[ p.length - 1 ];
      p.pop();
      this.innerHTML = ( p.join(" ") );
    }
  });
});

//only register Animation library if .panel exsists. ( attatched to main, so it should always. but better to be sure )
//.panel is on footer
if ( $( '.panel' ).length ) {
  ScrollTriggerInit;
}

// fixed logo parallax
//only run if .logo animate is on the page
//on about us page
if ( $( '.logo-animate' ).length ) {
  ScrollTrigger.create( {
    trigger: '.logo-animate',
    start: 'top 30%',
    end: 'bottom bottom-=20%',
    toggleClass: 'active',
    pin: true,
    scrub: 3,
    invalidateOnRefresh: true,
    // remove ScrollTrigger height
    onUpdate: () => $( '.logo-animate' ).css( 'height', '500px' )
  });
}

var parallaxImage = document.querySelectorAll( '.parallax-image' );

// parallax images
if ( $( '.parallax-image' ).length ) {
  parallaxImage.forEach( ( image, i ) => {
    gsap.to( image, {
      yPercent: -200,
      scrollTrigger: {
        trigger: image,
        start: 'top center',
        scrub: 3, 
        invalidateOnRefresh: true,
      }
    });
  });
}

// SINGLE CASE STUDIES PAGE ANIMATIONS
var projectInfoButtonContainer = document.querySelectorAll( '.project-info-button-container' );

if ( $( '.project-info-button-container' ).length ) {
  projectInfoButtonContainer.forEach( ( button, i ) => {

    ScrollTrigger.create( { 
      trigger: projectInfoButtonContainer,
      start: 'top top',
      onEnter: () => button.classList.add('sticky'),
      onLeaveBack: () => button.classList.remove('sticky')
     } )
  } )
}

// SCROLL TRIGGER BACKGROUND COLOR GRADIENT CHANGE
var scrollColorElems = document.querySelectorAll( '[data-scrollcolor]' );

if ( $( scrollColorElems.length ) ) {
  scrollColorElems.forEach( ( colorSection, i ) => {
    let defaultColor = '';
    let prevColor =
      i === 0 ? defaultColor : scrollColorElems[i - 1].dataset.scrollcolor;

    ScrollTrigger.create( {
      trigger: colorSection,
      start: 'top bottom-=20%',
      onEnter: () =>
        gsap.to( $( colorSection ).parent(), {
          backgroundColor: colorSection.dataset.scrollcolor,
          overwrite: 'auto'
        }),
      onLeaveBack: () =>
        gsap.to( $( colorSection ).parent(), {
          backgroundColor: prevColor,
          overwrite: 'auto'
        })
    });
  });
}

// HERO TEXT ANIMATION
if ( $( '[data-hero-slideup]' ).length ) {
  //make this a function so it waits till after our preloader has faded
  function slide() {
    ScrollTriggerInit;
    let heroSlideUp = document.querySelectorAll( '[data-hero-slideup]' );

    heroSlideUp.forEach( ( elem, i ) => {
      ScrollTrigger.create( {
        trigger: elem,
        onEnter: () => elem.classList.add( 'slide-up' ),
        onEnterBack: () => elem.classList.add( 'slide-up' ),
        onLeave: () => elem.classList.remove( 'slide-up' ),
        onLeaveBack: () => elem.classList.remove( 'slide-up' )
      });
    });
  }

  $( window ).on( 'load', function() {
    if( $( 'body' ).hasClass( 'home' ) ) {
      setTimeout( () => slide(), 2000 );
    } else {
      setTimeout( () => slide(), 500 );
    }
  });
}

// basic slide up animations - Text blocks - fade up animation
if ( $( '[data-slideup]' ).length ) {
  function slideUp() {
    ScrollTriggerInit;
    let slideUp = document.querySelectorAll( '[data-slideup]' );

    slideUp.forEach((elem, i) => {
      ScrollTrigger.create({
        trigger: elem,
        // start:"top center",
        // end:"bottom center",
        start:"top-=100% bottom-=25%",
        end:"top-=100% bottom",
        // markers: true,
        onEnter: () => elem.classList.add( 'slide-up' ),
      });
    });
  }
  $( window ).on( 'load', function() {
    setTimeout( () => slideUp(), 100 );
  });
}

//recalculate the dom positions of each panel after accordion open/close
  $( '.accordion' ).on( 'click', function() {
    setTimeout( () => {
      ScrollTrigger.refresh()
    }, 500 ) 
  });

// Cases pin section
if( $( '.case-blocks' ).length ) {
  ScrollTriggerInit;

  const caseImage = document.querySelectorAll( '.case-image' );
  const caseText = document.querySelectorAll( '.case-text-wrapper' );
  const caseWrapper = document.querySelectorAll( '.case-wrapper' );
  const caseInitialImage = document.querySelector( '.case-initial-image' )
  let caseScrollAnim;

  mm.add( '(min-width: 960px)', () => {

    // this setup code only runs when viewport is at least 960px wide
    ScrollTrigger.create( {
      trigger: caseInitialImage,
      start: 'top top',
      onEnter: () => { $( caseInitialImage ).find( '.initial-image' ).addClass( 'pin' ) },
      onEnterBack: () => { $( caseInitialImage ).find( '.initial-image' ).addClass( 'pin' ) },
      onLeave: () => { $( caseInitialImage ).find( '.initial-image' ).removeClass( 'pin' ) },
      onLeaveBack: () => { $( caseInitialImage ).find( '.initial-image' ).removeClass( 'pin' ) }
    } )

    caseScrollAnim = gsap.timeline({
      scrollTrigger: {
        trigger: '.case-blocks',
        start: 'center center',
        end: `+=${ $( caseImage ).length }00%`,
        pin: true,
        scrub: 1,
        invalidateOnRefresh: true,
      }
    })
  
    // Each Image gets animated up
    caseImage.forEach( ( elem, index ) => {
      caseScrollAnim.fromTo( elem, { y: `${ index }00%` }, { y: 0, duration: 4 })
    } )
  
    // Animation for case text down
    caseText.forEach( ( elem, index ) => {
      // Counter to delay animation
      let counter = ( index * 4.5 ) + 0.5;
  
      // If this is not the first case-text
      if( index > 0 ) {
        // Background color change
        caseScrollAnim.to( '.case-study', { backgroundColor: $( elem ).data( 'casecolor' ), duration: 2 }, counter )
  
        // Animate each case text up
        caseScrollAnim.fromTo( $( elem ), {
          y: 400,
          opacity: 0,
          zIndex: 1
        }, {
          y: 0,
          opacity: 1,
          duration: 2.25,
          zIndex: $( caseText ).length + 1
        }, counter )
      }
    } )
  
    // Animation for case text up
    caseText.forEach( ( elem, index ) => {
      // Counter to delay animation
      let counter = ( index * 4.5 ) + 3.5

      // if this is not the last case text
      if( index < caseText.length - 1 ) {

        // Animate case text up
        caseScrollAnim.fromTo( $( elem ), {
          y: 0,
          opacity: 1,
          zIndex: 10
        }, {
          y: -100,
          opacity: 0,
          duration: 2.25,
          zIndex: $( caseText ).length
        }, counter )
      }
    } )  
  });
  
  mm.add("(max-width: 959px)", () => {

    caseWrapper.forEach( ( elem ) => {

      // Change background color
      gsap.to( elem, {
        backgroundColor: $( elem ).children( '.case-text-wrapper' ).data( 'casecolor' ),
        scrollTrigger: {
          trigger: elem,
          start: 'top bottom',
        }
      })

      // case text animate in
      gsap.from( $( elem ).find( '.case-text' ), {
        y: 100,
        opacity: 0,
        scrollTrigger: {
          trigger: elem,
          start: 'top center-=40',
        }
      } )

      // Image parallax
      gsap.fromTo( $( elem ).find( '.case-image' ), 
      { y: -40 },
      { y: 0,
        scrollTrigger: {
          trigger: elem,
          start: 'top center',
          scrub: 2,
        }
      } )
    } )
  })
}

// Line ltr animation
var lineLtr = document.querySelectorAll( '.line-ltr' );

if ( $( '.line-ltr' ).length ) {
  lineLtr.forEach( line => {
    ScrollTrigger.create( {
      trigger: line,
      invalidateOnRefresh: true,
      // start: 'bottom bottom-=20%',
      onEnter: () => $( line ).addClass( 'active' )
    });
  });
}

// service item ltr animation
if ( $( '.marketing-item' ).length ) {
  ScrollTrigger.create( {
    trigger: $( '.marketing-services' ),
    invalidateOnRefresh: true,
    onToggle: self => {
      if ( self.isActive ) {
        setTimeout( function() {
          $( '.open .services .service-item-wrapper' ).addClass( 'animate-me' );
          $( '.open .category-text p' ).addClass( 'animate-me' );
        }, 540 );
      }
    }
  });

  var singleService = document.querySelectorAll( '.single-service' );

  singleService.forEach( singleService => {
    ScrollTrigger.create( {
      trigger: singleService,
      toggleClass: 'active',
      end: 'bottom top+=20%',
      start: 'top+=35% bottom-=20%'
    });
  });
}

// Image parallax Y axis on scroll
var imageParallaxElems = document.querySelectorAll( '.img-parallax' );

if ( $( imageParallaxElems.length ) ) {
  imageParallaxElems.forEach( ( imageParallaxElems, i ) => {
    // make the trigger the parent to account for the scale on the IMG
    let trigger = $(imageParallaxElems).parent()
    gsap.fromTo( 
      imageParallaxElems,
      { y: -20 },
      {
        y: 20,
        scrollTrigger: {
          trigger: trigger,
          scrub: 2,
        }
      }
     );
  });
}

// Video pause play functionality
var playPauseElems = document.querySelectorAll( '.video:not(.controlled) , dotlottie-player' );
const videoControl = document.querySelectorAll( '.controlled-video' );

$( window ).on( 'load', function() {
  if ( playPauseElems.length ){
    playPauseElems.forEach( ( video ) => {
  
      ScrollTrigger.create( {
        trigger: video,
        onToggle: self => {
  
          if ( self.isActive ) {
            video.play();
  
          } else {
            video.pause();
          }
        }
      });
    });
  }
});

if( $( videoControl ).length ) {
  videoControl.forEach( ( video ) => {
    let playPause = $( video ).find( '.playpause' );
    let mainVideo = $( video ).find( 'video' );
    let mute = $( video ).find( '.mute' );

    $( playPause ).on( 'click', () => {
      if( $( playPause ).hasClass( 'button-paused' ) ) {
        $( mainVideo ).trigger('pause');
        $( playPause ).removeClass( 'button-paused' );
        $( mute ).removeClass( 'mute-show' );
      } else {
        $( mainVideo ).trigger('play');
        $( playPause ).addClass( 'button-paused' );
        $( mute ).addClass( 'mute-show' );
      }
    } ) 

    $( mute ).on( 'click', () => {
      if( $( mainVideo ).prop( 'muted' ) ) {
        $( mainVideo ).prop( 'muted', false )
        $( mute ).removeClass( 'muted' )
      } else {
        $( mainVideo ).prop( 'muted', true )
        $( mute ).addClass( 'muted' )
      }
    } )
  } )
}

// Scroll top case study single
let scrollTopStart = $( '.case-study-gallery div:first-of-type' )
let scrollTopEnd = $( '.case-study-gallery .last' )

if ( $( scrollTopStart ).length ) {
  ScrollTrigger.create( {
    trigger: scrollTopStart,
    start: 'top top',
    endTrigger: scrollTopEnd,
    end: 'bottom-=65 bottom-=15%',
    onToggle: () => $( '.scroll-top-container .scroll-top' ).toggleClass('show-me'),
  });
}
// Scroll Slider
if( $( '.scroll-slider' ).length ) {
  ScrollTriggerInit;
  ScrollToInit;

  const scrollImage = gsap.utils.toArray( '.scroll-image' )
  const scrollTitle = gsap.utils.toArray( '.scroll-title' )
  const scrollDescr = document.querySelectorAll( '.scroll-description' )
  const scrollHeight = document.querySelector( '.ss-trigger' ).offsetHeight;
  const windowHeight = window.innerHeight;
  let slideScrollAnim;

  // Functions to add and remove active classes
  function titleActive() {
    $( scrollTitle ).removeClass( 'active' )
    $( this.targets() ).addClass( 'active' );
  }
  function descrActive() {
    $( scrollDescr ).removeClass( 'active' )
    $( this.targets() ).addClass( 'active' );
  }

  // Check to see height of container vs height on window and pin whichever is true
  if( ( scrollHeight + 100 ) < windowHeight ) {
    slideScrollAnim = gsap.timeline({
      scrollTrigger: {
        trigger: '.ss-trigger',
        start: 'center center',
        pin: true,
        scrub: 1,
        invalidateOnRefresh: true,
      }
    })
  } else {
    slideScrollAnim = gsap.timeline({
      scrollTrigger: {
        trigger: '.ss-container',
        start: 'center center',
        pin: true,
        scrub: 1,
        invalidateOnRefresh: true,
      }
    })
  }

  // Image slide up animation
  scrollImage.forEach( ( elem, index ) => {
    slideScrollAnim.fromTo( elem, { y: `${ index }00%` }, { y: 0, duration: 1 }, 'slide-' + index )
  } )

  // Toggle Title active
  scrollTitle.forEach( ( elem, index ) => {
    slideScrollAnim.to( elem, {
      duration: 0.6,
      ease: "linear",
      onUpdate: titleActive
    }, index + 1 )
  } )

  // Toggle description active
  scrollDescr.forEach( ( elem, index ) => {
    slideScrollAnim.to( elem, {
      duration: 0.6,
      ease: "linear",
      onUpdate: descrActive
    }, index + 1 )
  } )

  // Clicking each title makes it go to the start of each active animation
  $( scrollTitle ).on( 'click', function() {
    let prevSlide = slideScrollAnim.scrollTrigger.labelToScroll( $( this ).prev().data('id') );
    let currentSlide = slideScrollAnim.scrollTrigger.labelToScroll( $( this ).data('id') );
    let offset;

    if( prevSlide == 0 ) {
      offset = 0
    } else {
      offset = ( currentSlide - prevSlide );
    }

    gsap.to( window, { duration: 0.5, scrollTo: { y: slideScrollAnim.scrollTrigger.labelToScroll( $( this ).data('id') ), offsetY: -( offset ) - 10  } } )
  }  )
}

// marquee animation
if( $( '.sliding-text' ).length ) {
  ScrollTriggerInit;
  const slidingText = document.querySelectorAll( '.sliding-text' )

  // Horizontal Marquee Animation
  function horMarqueeText( elem ) {
    // Text scrolls on the x-axis
    let marquee = gsap.to( elem, {
      xPercent: -100,
      repeat: -1,
      duration: 60,
      ease: 'linear',
      paused: true,
    } ).totalProgress( 0.5 );

    ScrollTrigger.create({
      trigger: elem,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: () => marquee.play(),
      onEnterBack: () => marquee.play(),
      onLeave: () => marquee.pause(),
      onLeaveBack: () => marquee.pause(),
    })
    // User Scroll vs Marquee direction
    let currentScroll = 0;
    let isScrollingDown = true;

    window.addEventListener("scroll", function(){

      // Changes the animation back to forwards after 200ms
      function scrollDownChange() {
        setTimeout( () => {
          isScrollingDown = true
          gsap.to( marquee, {
            timeScale: 1
          });
        }, 200 )
      }
    
      if ( window.pageYOffset > currentScroll ) {
        isScrollingDown = true;
      } else {
        isScrollingDown = false;
        scrollDownChange();
      }
        
      gsap.to( marquee, {
        timeScale: isScrollingDown ? 1 : -1
      });
      
      currentScroll = window.pageYOffset
    });
  }

  slidingText.forEach( ( elem ) => {
    horMarqueeText( elem )
  } )
}

if( $( '.home-page-scroll-down' ).length ) {
  $( '.home-page-scroll-down' ).on( 'click', ( e ) => {
    e.preventDefault();

    $('html').animate(
      { scrollTop: $( '#intro' ).offset().top },800
    );
  } )
}